import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "psp-home" */ './views/home.vue'),
        meta: {
            title: 'Home',
            auth: undefined,
        }
    },
];

export default routes;